var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('div',{staticClass:"loading-view"},[_c('Spinner',{staticClass:"center gray"}),_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }